export const required = value => {
    value = typeof value === 'string' ? value.trim() : value;
    return typeof value !== 'undefined' && value != null && value !== '' ?
        undefined : 'This field can\'t be empty.';
};

export const email = value =>
    value && !/\S+@\S+\.\S+/i.test(value) ?
        'This field isn\'t a valid email address.' : undefined;

export const number = value =>
    value && !/^[-]?\d+(\.\d+)?$/i.test(value) ?
        'This field must be a number.' : undefined;

export const integer = value =>
    value && !/^-?\d+$/i.test(value) ?
        'This field must be an integer.' : undefined;

export const greaterThanZeroNumber = value =>
    value && parseFloat(value) <= 0 ?
        'This field must be greater than 0.' : undefined;

export const greaterThanOrEqualZeroNumber = value =>
    value && parseFloat(value) < 0 ?
        'This field must be greater than 0.' : undefined;

export const minLength3 = value =>
    !value || (typeof value === 'string' && value.length < 3) ?
        'This value is too short. It should have 3 characters or more' : undefined;

export const maxLength255 = value => {
    if (typeof value !== 'string') return undefined;
    const len = [...value].length;
    return len > 255 ? 'This value is too long. Make it shorter by '+(len - 255)+' characters' : undefined;
};

export const onlyPositiveNumber = value =>
    value && parseInt(value) < 0 ?
        'This field must be greater than 0.' : undefined;

export const currency = value =>
    value && !/^\d+(\.\d{1,2})?$/i.test(value) ?
        'This field must be a non negative number with up to 2 decimal places.' : undefined;
